module.exports = __webpack_public_path__ + "67aeb7a295843fe1430a8739c6e315a0.svg";